<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="absence-page container-fluid my-3">

        <!-- ── QR Panel ── -->
        <div class="card mb-3 border-primary">
            <div class="card-body py-3">
                <h6 class="card-title mb-3">
                    <i class="pi pi-qrcode me-1"></i> تسجيل الدفع بـ QR
                </h6>
                <div class="row align-items-end g-2 mb-3 p-3">
                    <div class="col-auto">
                        <label class="form-label mb-1 fw-semibold">البند المالي الحالي</label>
                        <Dropdown
                            v-model="selectedQrItem"
                            :options="financialItems"
                            optionLabel="name"
                            placeholder="اختر البند المالي..."
                            class="w-100"
                            style="min-width:220px"
                        />
                    </div>
                    <div v-if="selectedQrItem" class="col-auto">
                        <span class="badge bg-success fs-6 px-3 py-2">
                            <i class="pi pi-check-circle me-1"></i>
                            {{ selectedQrItem.name }}
                        </span>
                    </div>
                    <div v-else class="col-auto">
                        <span class="badge bg-secondary fs-6 px-3 py-2">لم يتم اختيار بند</span>
                    </div>
                </div>
                <BarcodeScanner
                    v-if="selectedQrItem"
                    mode="payment"
                    @scanned="handlePaymentQR"
                />
                <p v-else class="text-muted small mb-0">اختر البند المالي أولاً لتفعيل الماسح.</p>
                <div v-if="scanLookupLoading" class="mt-2 text-primary small">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    جاري البحث عن الطالب...
                </div>
            </div>
        </div>

        <!-- ── Filters ── -->
        <div class="filter my-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h4>
                    المدفوعات — {{ gradeName }}
                    <span v-if="paggination">({{ paggination }})</span>
                </h4>
            </div>
            <div class="row">
                <div class="col-lg-8 col-md-12 col-12">
                    <div class="form-group">
                        <label for="pay-search">ابحث</label>
                        <input type="search" id="pay-search" class="form-control" placeholder="ابحث باسم الطالب"
                            v-model="word" @keyup="fetchStudents(1)">
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label>الجنس</label>
                        <Dropdown v-model="gender" :options="gender_list" optionLabel="title"
                            placeholder="الجنس" @change="fetchStudents(1)" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 col-12">
                    <div class="d-flex">
                        <div class="form-group d-flex flex-column mx-1">
                            <label class="non_opacity">Excel</label>
                            <button class="btn btn-success px-3" @click="exportToExcel">
                                <i class="pi pi-file-excel"></i>
                            </button>
                        </div>
                        <div class="form-group d-flex flex-column mx-1">
                            <label class="non_opacity">طباعة</label>
                            <button class="btn btn-danger px-3" v-print="'#paymentsTable'">
                                <i class="pi pi-file-pdf"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ── Bulk unpaid notify ── -->
        <div class="row mb-3 mt-1" v-if="financialItems.length > 0">
            <div class="col-12">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <Dropdown
                        v-model="bulkNotifyItem"
                        :options="financialItems"
                        optionLabel="name"
                        placeholder="اختر البند لإشعار غير المسددين..."
                        style="min-width:250px"
                    />
                    <button class="btn btn-warning" @click="sendBulkUnpaidNotify"
                        :disabled="bulkNotifying || !bulkNotifyItem">
                        <i class="pi pi-bell me-1"></i>
                        {{ bulkNotifying ? 'جاري الإرسال...' : 'إرسال إشعار غير المسددين' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- ── No items warning ── -->
        <div v-if="!loadingItems && financialItems.length === 0" class="alert alert-warning">
            لا توجد بنود مالية لهذا الفصل.
            <router-link to="/financial-settings" class="alert-link ms-1">
                أضف بنوداً من الإعدادات المالية
            </router-link>
        </div>

        <!-- ── Main Table ── -->
        <div class="row">
            <div id="paymentsTable" class="a4">
                <div class="first-screen-pdf">
                    <h1>شيت المدفوعات</h1>
                    <h2>{{ gradeName }}</h2>
                    <h3>{{ gender?.id === 1 ? 'بنين' : gender?.id === 2 ? 'بنات' : '' }} ({{ paggination }})</h3>
                </div>

                <table class="table table-striped table-confirm">
                    <thead>
                        <tr>
                            <th scope="col" rowspan="2">رقم</th>
                            <th scope="col" rowspan="2">الاسم</th>
                            <th scope="col" rowspan="2">رقم ولي الأمر</th>
                            <th scope="col" :colspan="financialItems.length || 1">
                                البنود المالية
                            </th>
                        </tr>
                        <tr>
                            <th v-if="financialItems.length === 0" class="month text-muted">—</th>
                            <th v-for="item in financialItems" :key="item.id" class="month pay-col">
                                {{ item.name }}
                                <div v-if="item.amount" class="item-amount">{{ item.amount }} ج</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(student, index) in reservations.data" :key="student.user_id"
                            :data-student-row="student.user_id"
                            :class="{ 'row-highlight': highlightedStudentId === student.user_id }">
                            <td data-label="رقم">{{ rowNumber(index) }}</td>
                            <td data-label="الاسم">{{ student.name }}</td>
                            <td data-label="رقم ولي الأمر">{{ student.parent_phone }}</td>
                            <td v-if="financialItems.length === 0"></td>
                            <td v-for="item in financialItems" :key="item.id"
                                class="pay-cell"
                                :class="{ 'pay-cell--paid': isPaid(student.user_id, item.id) }"
                                :title="getPaidTitle(student.user_id, item.id)"
                                @click="handleCellClick(student, item)">
                                <i v-if="isPaid(student.user_id, item.id)" class="pi pi-check pay-check"></i>
                            </td>
                        </tr>

                        <!-- Extra rows for print pagination -->
                        <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
                            <td>{{ (reservations.data?.length ?? 0) + n }}</td>
                            <td></td>
                            <td></td>
                            <td v-if="financialItems.length === 0"></td>
                            <td v-for="item in financialItems" :key="item.id"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- ── Pagination ── -->
        <div class="row">
            <div class="col-md-10 col-12">
                <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchStudents">
                    <template v-slot:prev-nav>&lt;</template>
                    <template v-slot:next-nav>&gt;</template>
                </pagination>
            </div>
            <div class="col-md-2 col-12 mt-md-0 mt-3">
                <div class="form-group d-flex md-justify-content-end justify-content-center">
                    <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                        placeholder="عدد الطلاب" @change="fetchStudents(1)" />
                </div>
            </div>
        </div>

    </div>

    <!-- ── Mobile warning ── -->
    <div class="absence-page-mobile">
        يجب فتح هذا الجدول من جهاز الكمبيوتر
    </div>

    <!-- ── Payment Details Dialog ── -->
    <Dialog v-model:visible="detailsVisible" modal header="تفاصيل الدفع"
        :style="{ width: '40vw' }" :breakpoints="{ '1199px': '65vw', '575px': '90vw' }">
        <div v-if="selectedPayment">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th class="bg-light" style="width:40%">الطالب</th>
                        <td>{{ selectedPayment.student_name }}</td>
                    </tr>
                    <tr>
                        <th class="bg-light">البند المالي</th>
                        <td>{{ selectedPayment.item_name }}</td>
                    </tr>
                    <tr v-if="selectedPayment.amount">
                        <th class="bg-light">القيمة</th>
                        <td>{{ selectedPayment.amount }} جنيه</td>
                    </tr>
                    <tr>
                        <th class="bg-light">تاريخ الدفع</th>
                        <td>{{ formatDate(selectedPayment.paid_at) }}</td>
                    </tr>
                    <tr>
                        <th class="bg-light">وقت الدفع</th>
                        <td>{{ formatTime(selectedPayment.paid_at) }}</td>
                    </tr>
                    <tr v-if="selectedPayment.paid_by_name">
                        <th class="bg-light">سُجّل بواسطة</th>
                        <td>{{ selectedPayment.paid_by_name }}</td>
                    </tr>
                    <tr v-if="selectedPayment.notes">
                        <th class="bg-light">ملاحظات</th>
                        <td>{{ selectedPayment.notes }}</td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-danger mt-2" @click="removePayment">
                <i class="pi pi-trash me-1"></i> إلغاء تسجيل الدفع
            </button>
        </div>
    </Dialog>

    <!-- ── Notification Dialog ── -->
    <Dialog v-model:visible="notifyVisible" modal header="رسالة تأكيد الدفع"
        :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <Textarea v-model="paymentMessage" style="display:block;width:100%;" cols="30" rows="7" />
        <div class="text-end mt-1" :class="paymentMessage.length > 70 ? 'text-danger' : 'text-success'">
            {{ paymentMessage.length }} حرف
            <span class="ms-2">عدد الرسائل: {{ smsCount }}</span>
        </div>
        <button type="button" class="PrimaryButton mt-3" @click="sendNotification">إرسال</button>
    </Dialog>
</template>

<script>
import axios from 'axios';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import pagination from 'laravel-vue-pagination';
import * as XLSX from 'xlsx/xlsx.mjs';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BarcodeScanner from '@/components/global/BarcodeScanner.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';
import { useNotificationStore } from '@/stores/useNotificationStore.js';

export default {
    name: 'PaymentsPage',
    components: { Dropdown, Dialog, Textarea, pagination, Breadcrumb, BarcodeScanner },

    data() {
        return {
            // Students (paginated)
            reservations: { data: [] },
            currentPage: 1,
            paggination: '',
            per_page: null,
            per_pages: [
                { title: 'الكل', id: 10000 },
                { title: 10,     id: 10 },
                { title: 25,     id: 25 },
                { title: 50,     id: 50 },
                { title: 100,    id: 100 },
            ],

            // Filters
            word: '',
            gender: { id: 1, title: 'ولد' },
            gender_list: [
                { id: 1, title: 'ولد' },
                { id: 2, title: 'بنت' },
            ],

            // Financial data
            financialItems: [],
            loadingItems: true,
            selectedQrItem: null,
            // paymentsMap[student_id][item_id] = { id, paid_at, paid_by_name, notes }
            paymentsMap: {},

            // QR scan lookup
            scanLookupLoading: false,
            highlightedStudentId: null,

            // Payment details dialog
            detailsVisible: false,
            selectedPayment: null,

            // Notification dialog
            notifyVisible: false,
            paymentMessage: '',
            currentParentPhone: null,

            // Bulk unpaid notify
            bulkNotifyItem: null,
            bulkNotifying: false,

            // Templates cache
            templates: {},
        };
    },

    computed: {
        gradeStore() { return useGradeStore(); },
        notificationStore() { return useNotificationStore(); },

        currentGrade() {
            const slug = this.$route.params.gradeSlug ?? this.$route.params.slug;
            return this.gradeStore.activeGrades.find(g => g.slug === slug)
                ?? this.gradeStore.allGrades.find(g => g.slug === slug)
                ?? this.gradeStore.currentGrade;
        },

        gradeName() { return this.currentGrade?.name ?? ''; },

        perPageValue() { return this.per_page ? this.per_page.id : 10; },

        smsCount() { return Math.ceil(this.paymentMessage.length / 70) || 1; },

        extraRows() {
            return 27 - (Number(this.paggination) % 27);
        },

        breadcrumbs() {
            return [
                { name: 'الرئيسية', path: '/' },
                { name: this.gradeName || 'الفصل', path: '/' },
                { name: 'المدفوعات', path: this.$route.fullPath },
            ];
        },
    },

    methods: {
        // ── Data Loading ────────────────────────────────────────────────

        async fetchStudents(page = 1) {
            if (!this.currentGrade) return;
            this.currentPage = page;

            const formData = new FormData();
            formData.append('status', 1);
            formData.append('order_by_name', 1);
            formData.append('academic_year_id', this.currentGrade.id);
            if (this.word) formData.append('word', this.word);
            if (this.gender) formData.append('gender', this.gender.id);

            axios.defaults.headers.common['per_page'] = this.perPageValue;

            axios.post(`/all_reservations?page=${page}`, formData)
                .then(res => {
                    this.reservations = res.data.data;
                    this.paggination = res.data.data.meta?.total ?? 0;
                })
                .catch(() => { this.reservations = { data: [] }; });
        },

        async loadFinancialItems() {
            this.loadingItems = true;
            if (!this.currentGrade) return;
            const res = await axios.get('/financial-items', {
                params: { academic_year_id: this.currentGrade.id },
            });
            this.financialItems = res.data.data ?? [];
            this.loadingItems = false;
        },

        async loadPayments() {
            if (!this.currentGrade) return;
            const res = await axios.get(`/payments/by-academic-year/${this.currentGrade.id}`);
            const data = res.data.data ?? [];
            const map = {};
            for (const row of data) {
                map[row.student_id] = {};
                for (const [itemId, details] of Object.entries(row.payment_details ?? {})) {
                    map[row.student_id][itemId] = details;
                }
            }
            this.paymentsMap = map;
        },

        // ── Payment State ────────────────────────────────────────────────

        isPaid(studentId, itemId) {
            return !!(this.paymentsMap[studentId]?.[String(itemId)]);
        },

        getPaidTitle(studentId, itemId) {
            const d = this.paymentsMap[studentId]?.[String(itemId)];
            if (!d) return '';
            const who = d.paid_by_name ? `\nبواسطة: ${d.paid_by_name}` : '';
            return `تم الدفع: ${this.formatDate(d.paid_at)}${who}`;
        },

        rowNumber(index) {
            return (this.currentPage - 1) * this.perPageValue + index + 1;
        },

        // ── Interactions ────────────────────────────────────────────────

        async handleCellClick(student, item) {
            if (this.isPaid(student.user_id, item.id)) {
                // Show details
                const d = this.paymentsMap[student.user_id][String(item.id)];
                this.selectedPayment = {
                    student_id: student.user_id,
                    student_name: student.name,
                    item_id: item.id,
                    item_name: item.name,
                    amount: item.amount,
                    paid_at: d.paid_at,
                    paid_by_name: d.paid_by_name,
                    notes: d.notes,
                };
                this.detailsVisible = true;
            } else {
                // Mark as paid
                await this.markPaid(student, item);
            }
        },

        async markPaid(student, item) {
            const res = await axios.post('/payments/mark-paid', {
                student_id: student.user_id,
                financial_item_id: item.id,
            }).catch(err => { console.error(err); return null; });

            if (!res?.data?.status) return;

            // Refresh payment map
            await this.loadPayments();

            this.notificationStore.push({
                icon:  'success',
                title: 'تم تسجيل الدفع',
                text:  `${student.name} — ${item.name}`,
            });

            // The backend already sent the "payment_confirmation" WhatsApp message
            // automatically (see StudentPaymentController::sendPaymentConfirmation) —
            // no manual send step needed here. Only surface a warning if it failed;
            // the payment itself is already committed either way.
            if (res.data.whatsapp_sent === false) {
                this.notificationStore.push({
                    icon:  'warning',
                    title: 'تعذّر إرسال رسالة تأكيد الدفع عبر واتساب',
                    text:  student.name,
                });
            }
        },

        async removePayment() {
            const result = await Swal.fire({
                title: 'إلغاء تسجيل الدفع',
                html: `سيتم إلغاء دفع <strong>${this.selectedPayment.item_name}</strong><br>للطالب: ${this.selectedPayment.student_name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء الدفع',
                cancelButtonText: 'لا',
                confirmButtonColor: '#dc3545',
            });
            if (!result.isConfirmed) return;

            await axios.post('/payments/mark-paid', {
                student_id: this.selectedPayment.student_id,
                financial_item_id: this.selectedPayment.item_id,
            });
            this.detailsVisible = false;
            await this.loadPayments();
        },

        // ── Templates ────────────────────────────────────────────────

        async loadTemplates() {
            try {
                const res = await axios.get('/whatsapp-templates');
                const list = res.data.data ?? [];
                this.templates = Object.fromEntries(list.map(t => [t.code, t]));
            } catch { /* non-fatal */ }
        },

        // ── Notification ────────────────────────────────────────────────

        buildMessage(studentName, item, paidAt) {
            const tpl = this.templates['payment_confirmation'];
            if (tpl?.is_active) {
                return tpl.message
                    .replace(/\{\{student_name\}\}/g, studentName)
                    .replace(/\{\{fee_name\}\}/g, item.name)
                    .replace(/\{\{fee_amount\}\}/g, item.amount ?? '')
                    .replace(/\{\{date\}\}/g, this.formatDate(paidAt))
                    .replace(/\{\{time\}\}/g, this.formatTime(paidAt))
                    .replace(/\{\{teacher_name\}\}/g, 'أ.مصطفى حسني');
            }
            const amountLine = item.amount ? `\nقيمة الرسوم:\n${item.amount} جنيه\n` : '';
            return `تم تسجيل سداد رسوم الطالب:\n${studentName}\n\nالبند المالي:\n${item.name}\n${amountLine}\nتاريخ السداد:\n${this.formatDate(paidAt)}\n\nالوقت:\n${this.formatTime(paidAt)}\n\nشكراً لكم.`;
        },

        async sendBulkUnpaidNotify() {
            if (!this.currentGrade || !this.bulkNotifyItem) return;

            const result = await Swal.fire({
                title:             'إرسال إشعار غير المسددين',
                html:              `سيتم إرسال إشعار لجميع الطلاب الذين لم يسددوا <strong>${this.bulkNotifyItem.name}</strong>`,
                icon:              'question',
                showCancelButton:  true,
                confirmButtonText: 'نعم، إرسال',
                cancelButtonText:  'إلغاء',
            });

            if (!result.isConfirmed) return;

            this.bulkNotifying = true;
            try {
                const res = await axios.post('/payments/bulk-notify-unpaid', {
                    academic_year_id:  this.currentGrade.id,
                    financial_item_id: this.bulkNotifyItem.id,
                });
                const { total_recipients, queued_chunks, failed_chunks } = res.data;
                Swal.fire({
                    icon:  queued_chunks > 0 ? 'success' : 'info',
                    title: 'اكتمل الإرسال',
                    html:  `عدد المستلمين: <strong>${total_recipients}</strong><br>دفعات تم إرسالها: <strong>${queued_chunks}</strong><br>دفعات فشلت: <strong>${failed_chunks}</strong>`,
                    timer: 6000,
                    showConfirmButton: true,
                });
            } catch {
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'حدث خطأ أثناء الإرسال', timer: 3000, showConfirmButton: false });
            } finally {
                this.bulkNotifying = false;
            }
        },

        async sendNotification() {
            const phone = '2' + this.currentParentPhone;

            // 1. Check WhatsApp
            let hasWhatsApp = false;
            try {
                const r = await axios.post('/whatsapp/check', { phone });
                hasWhatsApp = r.data.has_whatsapp === true;
            } catch { hasWhatsApp = false; }

            // 2. Send WhatsApp
            if (hasWhatsApp) {
                try {
                    const r = await axios.post('/whatsapp/send', { phone, message: this.paymentMessage });
                    if (r.data.success) {
                        Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة عبر واتساب بنجاح', timer: 1500, showConfirmButton: false });
                        this.notifyVisible = false;
                        return;
                    }
                } catch { /* fall through */ }
            }

            // 3. SMS fallback — same implementation as attendance
            const formData = new FormData();
            formData.append('SenderName', 'SMS invite');
            formData.append('RequestID', Date.now());
            formData.append('PhoneNumber', phone);
            formData.append('Message', this.paymentMessage);

            await axios.post(
                'https://hubapi.advansystelecom.com/api/bulkSMS/ForwardSMS',
                formData,
                { headers: { 'Authorization': '667d0a1e-f2b3-4bd5-8569-360b6e7b80b0', 'Content-Type': 'application/json' } }
            ).then(res => {
                if (res.data === '1') {
                    Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة بنجاح', timer: 1500, showConfirmButton: false });
                    this.notifyVisible = false;
                }
            }).catch(err => {
                const code = err.response?.data?.Message;
                const msgs = { '-1': 'رمز التوثيق غير صحيح', '-2': 'رقم الجوال فارغ', '-3': 'نص الرسالة فارغ', '-4': 'اسم المرسل غير صحيح', '-5': 'لا يوجد رصيد كافٍ' };
                Swal.fire({ icon: 'error', title: 'خطأ', text: msgs[code] ?? 'حدث خطأ غير متوقع', timer: 3000, showConfirmButton: false });
            });
        },

        // ── Formatting ────────────────────────────────────────────────

        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
        },

        formatTime(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            let h = d.getHours();
            const m = String(d.getMinutes()).padStart(2, '0');
            const period = h >= 12 ? 'مساءً' : 'صباحاً';
            h = h % 12 || 12;
            return `${h}:${m} ${period}`;
        },

        // ── QR Payment ────────────────────────────────────────────────

        // Looks up students matching a scanned value (student id, reservation id, or
        // reservation code) within the current grade, via the same search endpoint
        // fetchStudents() uses.
        async searchStudentsForScan(term) {
            const formData = new FormData();
            formData.append('status', 1);
            formData.append('academic_year_id', this.currentGrade.id);
            formData.append('word', term);
            axios.defaults.headers.common['per_page'] = 10000;

            const res = await axios.post('/all_reservations', formData);
            return res.data.data?.data ?? [];
        },

        async handlePaymentQR({ raw, studentId }) {
            console.log('[Payments] Callback fired', { raw, studentId });

            const term = studentId ?? raw;
            if (!term || !this.selectedQrItem || !this.currentGrade) return;

            console.log('[Payments] Lookup started for:', term);
            this.scanLookupLoading = true;
            try {
                const matches = await this.searchStudentsForScan(term);

                if (!matches.length) {
                    console.log('[Payments] Lookup failed: no student found for', term);
                    Swal.fire({ icon: 'info', title: 'لم يتم العثور على الطالب', timer: 2500, showConfirmButton: false });
                    return;
                }

                let student;
                if (matches.length === 1) {
                    student = matches[0];
                } else {
                    console.log('[Payments] Lookup ambiguous, multiple matches:', matches.length);
                    student = await this.chooseFromMultipleMatches(matches);
                    if (!student) return; // user cancelled
                }

                console.log('[Payments] Lookup success:', student);
                await this.markPaidFromScan(student);
            } catch (err) {
                console.log('[Payments] Lookup failed:', err);
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'تعذّر البحث عن الطالب', timer: 2500, showConfirmButton: false });
            } finally {
                this.scanLookupLoading = false;
            }
        },

        async chooseFromMultipleMatches(matches) {
            const inputOptions = Object.fromEntries(
                matches.map((s) => [s.user_id, `${s.name}${s.parent_phone ? ' - ' + s.parent_phone : ''}`])
            );
            const { value: chosenId } = await Swal.fire({
                icon: 'question',
                title: 'تم العثور على أكثر من طالب',
                input: 'radio',
                inputOptions,
                confirmButtonText: 'اختيار',
                cancelButtonText: 'إلغاء',
                showCancelButton: true,
            });
            if (!chosenId) return null;
            return matches.find((s) => String(s.user_id) === String(chosenId)) ?? null;
        },

        // Marks the resolved student paid for the selected financial item, then
        // scrolls to and highlights their row in the table.
        async markPaidFromScan(student) {
            const res = await axios.post('/payments/qr-mark-paid', {
                student_id: student.user_id,
                financial_item_id: this.selectedQrItem.id,
            });
            console.log('[Payments] Page action executed: payment marked for', student.user_id);

            if (res.data.status === 'already_paid') {
                this.notificationStore.push({
                    icon:  'warning',
                    title: 'تم تسجيل الدفع مسبقاً',
                    text:  `${res.data.student_name} — ${res.data.item_name}`,
                });
            } else {
                this.notificationStore.push({
                    icon:  'success',
                    title: 'تم تسجيل الدفع',
                    text:  `${res.data.student_name} — ${res.data.item_name}`,
                });
                await this.loadPayments();

                // The backend already sent the "payment_confirmation" WhatsApp message
                // automatically — only surface a warning if it failed; the payment
                // itself is already committed either way.
                if (res.data.whatsapp_sent === false) {
                    this.notificationStore.push({
                        icon:  'warning',
                        title: 'تعذّر إرسال رسالة تأكيد الدفع عبر واتساب',
                        text:  res.data.student_name,
                    });
                }
            }

            await this.revealStudentRow(student.user_id);
        },

        // Ensures the given student's row is actually rendered (clears filters/paging
        // that might otherwise hide it), then scrolls to it and flashes a highlight.
        async revealStudentRow(studentId) {
            const alreadyVisible = this.reservations.data?.some((s) => s.user_id === studentId);
            if (!alreadyVisible) {
                this.word = '';
                this.gender = null;
                this.per_page = this.per_pages[0]; // "الكل"
                await this.fetchStudents(1);
            }

            await this.$nextTick();
            // NOTE: this.$el isn't a queryable element here — this page's template has
            // multiple root nodes (a Vue 3 fragment), so $el resolves to a non-element
            // fragment anchor rather than a container with .querySelector(). Query the
            // document directly instead (data-student-row values are unique page-wide).
            const row = document.querySelector(`[data-student-row="${studentId}"]`);
            if (row) {
                row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            this.highlightedStudentId = studentId;
            setTimeout(() => {
                if (this.highlightedStudentId === studentId) this.highlightedStudentId = null;
            }, 2000);
        },

        // ── Export ────────────────────────────────────────────────

        exportToExcel() {
            const table = document.getElementById('paymentsTable').cloneNode(true);
            const ws = XLSX.utils.table_to_sheet(table);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'المدفوعات');
            XLSX.writeFile(wb, `مدفوعات-${this.gradeName}.xlsx`);
        },
    },

    async mounted() {
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();

        await Promise.all([this.loadFinancialItems(), this.loadPayments(), this.loadTemplates()]);
        this.fetchStudents(1);

        // Restore QR selected item from localStorage
        const saved = localStorage.getItem('selected_payment_item');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                const match = this.financialItems.find(i => i.id === parsed.id);
                if (match) this.selectedQrItem = match;
            } catch {}
        }
    },

    watch: {
        '$route.params.gradeSlug': {
            async handler() {
                await Promise.all([this.loadFinancialItems(), this.loadPayments()]);
                this.fetchStudents(1);
                // Re-resolve selected QR item after reloading financial items
                const saved = localStorage.getItem('selected_payment_item');
                if (saved) {
                    try {
                        const parsed = JSON.parse(saved);
                        const match = this.financialItems.find(i => i.id === parsed.id);
                        this.selectedQrItem = match ?? null;
                    } catch {}
                }
            },
        },

        selectedQrItem(val) {
            if (val) {
                localStorage.setItem('selected_payment_item', JSON.stringify({ id: val.id, name: val.name }));
            } else {
                localStorage.removeItem('selected_payment_item');
            }
        },
    },
};
</script>

<style scoped>
/* ── Payment cells ── */
.pay-cell {
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    min-width: 55px;
    transition: background-color 0.15s;
}
.pay-cell:hover {
    background-color: #e8f5e9 !important;
}
.pay-cell--paid {
    background-color: #d4edda;
}
.pay-cell--paid:hover {
    background-color: #c3e6cb !important;
}
.pay-check {
    color: #28a745;
    font-size: 1rem;
}

/* ── QR scan result ── */
.row-highlight {
    animation: row-highlight-flash 2s ease-out;
}
@keyframes row-highlight-flash {
    0%, 40%   { background-color: #fff3cd; }
    100%      { background-color: transparent; }
}

/* ── Column headers ── */
th.pay-col {
    min-width: 60px;
    font-size: 0.82rem;
    text-align: center;
    vertical-align: bottom;
    white-space: nowrap;
}
.item-amount {
    font-size: 0.7rem;
    color: #6c757d;
    font-weight: normal;
}

/* ── Print styles ── */
@media print {
    .table > :not(caption) > * > * {
        border-width: 2px !important;
        border-color: #000 !important;
    }
    table * {
        font-size: 0.8rem !important;
        font-weight: 900;
    }
    th.pay-col {
        min-width: 30px !important;
        width: 30px !important;
        white-space: normal;
    }
    .pay-cell--paid {
        background-color: #d4edda !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
    .empty-row {
        display: table-row !important;
    }
}

.empty-row {
    display: none;
}
</style>
